import styled from 'styled-components'

export const SpeakerTextContainer = styled.div<{
  $background: string
  $backgroundTheme: string
  $mainImage: boolean
  $useCase: string
}>`
  ${({ theme, $background, $backgroundTheme, $mainImage, $useCase }) => {
    //* default to white/grey theme
    let dottedSplitterColorTop = theme.webMktNewPalette.black
    let dottedSplitterColorBottom = theme.webMktNewPalette.deepBlue[60]
    let seeMoreBioColor = theme.webMktNewPalette.action.light.primary
    let shortBodyDetailColor = theme.webMktNewPalette.deepBlue[55]

    let themeStyles = ``
    if ($backgroundTheme === 'Dark') {
      themeStyles = `
        background-color: ${theme.webMktNewPalette.deepBlue[70]};
        .SpeakerText__Intro,
        .SpeakerText__Bottom {
          p, h2 {
            color: ${theme.webMktNewPalette.white}
          }
        }
      `
      shortBodyDetailColor = theme.webMktNewPalette.white
      seeMoreBioColor = theme.webMktPalette.text.actionDark
      dottedSplitterColorTop = theme.webMktNewPalette.deepBlue[15]
      dottedSplitterColorBottom = theme.webMktNewPalette.deepBlue[30]
    } else if ($backgroundTheme === 'Grey') {
      themeStyles = `
        background-color: ${theme.webMktNewPalette.deepBlue[10]};
      `
    }

    themeStyles += `
      .SpeakerText__Bio-Body {
        margin-top: 8px;
        max-height: 48px;
        overflow: hidden;

        p {
          color: ${shortBodyDetailColor};
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: initial;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          }
        }
      }

      p.SpeakerText__Bio-More {
        margin-top: 8px;
        color: ${seeMoreBioColor};
      }

      .SpeakerText__Dots {
        background-image: linear-gradient(
          to right,
            ${dottedSplitterColorTop} 2px,
          rgba(255, 255, 255, 0) 0%
        ),
        linear-gradient(to right, ${dottedSplitterColorTop} 2px, rgba(255, 255, 255, 0) 0%);
      }

      .SpeakerText__SpeakerLabel {
        &:before {
          background-image: linear-gradient(
            to right,
            ${dottedSplitterColorBottom} 2px,
            rgba(255, 255, 255, 0) 0%
          );
        }
      }
    `

    let useCaseStyles = ``
    let accentOffset = $mainImage ? '16px' : '0px'
    if ($useCase === 'Centered') {
      useCaseStyles = `
        .SpeakerText__Intro {
          margin: 0 auto;
        }

        .SpeakerText__MainImage {
          display: block;
          margin: 0 auto;
        }
      `
    } else if ($useCase === 'Number Accent') {
      useCaseStyles = `
        .SpeakerText__Accent {
          font-style: normal;
          font-weight: 200;
          font-size: 132px;
          line-height: 140px;
          letter-spacing: -8px;
          color: #ed145b;
          vertical-align: top;
          width: 180px;
          margin: 0;

          ${theme.breakpoints.down('md')} {
            width: 140px;
            font-size: 112px;
            line-height: 110px;
          }

          ${theme.breakpoints.down('sm')} {
            width: unset;
            font-size: 104px;
            line-height: 110px;
            position: absolute;
            left: 0;
            top: 0;
            transform: translateX(calc(-100% + ${accentOffset}));
            z-index: 2;
          }

          ${theme.breakpoints.down('xs')} {
            line-height: 56px;
            font-size: 56px;
            letter-spacing: -4px;
            transform: translateY(calc(-100% + ${accentOffset}));
          }
        }
      `
    } else if ($useCase === 'Image Accent') {
      useCaseStyles = `
        .SpeakerText__AccentImage {
          max-width: 180px;
          vertical-align: top;

          ${theme.breakpoints.down('sm')} {
            position: absolute;
            left: 0;
            top: 0;
            transform: translateX(calc(-100% + ${accentOffset}));
            width: 140px;
            height: 140px;
            object-fit: contain;
            z-index: 2;
          }

          ${theme.breakpoints.down('xs')} {
            transform: translateY(calc(-100% + ${accentOffset}));
            width: 56px;
            height: 56px;
          }
        }
      `
    }

    if ($useCase != 'Centered')
      useCaseStyles += `
        .SpeakerText__Intro {
          margin-left: 24px;

          ${theme.breakpoints.down('md')} {
            max-width: 632px;
          }

          ${theme.breakpoints.down('sm')} {
            max-width: 547px;
            margin-left: 0px;
          }
        }
      `

    let backgroundImageStyles = ``
    if ($background) {
      backgroundImageStyles = `
        background-image: url(${$background});
        background-repeat: no-repeat;
        background-position: top center;
      `
    }

    return `
      ${themeStyles}
      ${useCaseStyles}
      ${backgroundImageStyles}
      padding: 64px 16px;
    `
  }}

  > div {
    max-width: 996px;
    margin: 0 auto;
  }

  .SpeakerText__Bottom {
    margin-top: 48px;
    overflow: hidden;
  }

  .SpeakerText__Dots {
    background-position: top center, top 30px center;
    background-size: 22px 2px;
    background-repeat: repeat-x;
    height: 34px;
    max-width: 1200px;
    padding: 0 16px;
    width: 100%;
    margin-bottom: 64px;
    box-sizing: border-box;

    ${({ theme }) => theme.breakpoints.down('md')} {
      max-width: 960px;
    }
  }

  .SpeakerText__AccentContainer {
    position: relative;
  }

  .SpeakerText__Bio-Headshot {
    height: 160px;
    width: 160px;
    border-radius: 50%;
    flex-shrink: 0;
    object-fit: cover;
  }

  .SpeakerText__Bios-Container {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 24px;
    grid-row-gap: 32px;
  }

  .SpeakerText__Bio {
    display: flex;
    align-items: center;
    gap: 44px;
  }

  .SpeakerText__SpeakerLabel {
    position: relative;
    margin-bottom: 32px;
    display: inline-block;

    &:before {
      content: '';
      position: absolute;
      left: calc(100% + 24px);
      top: 50%;
      transform: translateY(-50%);
      width: 1000px;
      height: 2px;
      background-position: top center;
      background-size: 22px 2px;
      background-repeat: repeat-x;
    }
  }

  .SpeakerText__MainImage {
    position: relative;
    max-width: 690px;
    margin-bottom: 48px;
  }

  p {
    margin: 0;
  }

  .SpeakerText__Intro {
    max-width: 690px;
  }

  .SpeakerText__Bio-Name {
    margin-bottom: 4px;
  }

  .SpeakerText__Top {
    display: flex;
  }

  .SpeakerText__Title {
    margin-top: 8px;
  }

  .SpeakerText__Description {
    margin-top: 24px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    > div {
      max-width: 960px;
    }

    .SpeakerText__MainImage {
      max-width: 632px;
    }

    .SpeakerText__Bio-Headshot {
      height: 140px;
      width: 140px;
    }

    .SpeakerText__Bio {
      gap: 24px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-top: 48px;

    > div {
      max-width: 547px;
    }

    .SpeakerText__Bios-Container {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      grid-row-gap: 24px;
    }

    .SpeakerText__Bio-Headshot {
      height: 128px;
      width: 128px;
    }

    .SpeakerText__Bio {
      gap: 16px;
    }

    .SpeakerText__Bios-Container {
      max-width: 547px;
      margin: 0 auto;
    }

    .SpeakerText__MainImage {
      max-width: 100%;
      margin-left: 0;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding-bottom: 48px;

    .SpeakerText__Bio-Headshot {
      height: 70px;
      width: 70px;
    }
  }
`
